<template>
    <div id="content">
        <div class="container text-center">
            <h1 style="font-size: 210px; color: #c70000; font-weight: 100">Ops...</h1>
            <h3>Faça seu cadastro ou entre para ver detalhes do produto.</h3>
        </div>
    </div>
</template>

<script>
    export default {}
</script>



// WEBPACK FOOTER //
// 404.vue?718c0f46